import { RecentBotsService } from '../services/recent-bots.service';
import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { AdminService } from '@shared-angular/services/admin.service';
import { FusionService } from '@shared-angular/services/fusion.service';
import { LoginService } from '@shared-angular/services/login.service';
import { McpService } from '@shared-angular/services/mcp.service';
import { BotidService } from '@shared-angular/services/ragai/botid.service';
import { StageAdminService } from '@shared-angular/services/stage-admin.service';
import { ChatbotConfig } from '@shared/index';
import { BlocklyPluginsService } from 'src/app/blockly-plugins.service';
import { BlocklyStorageService } from '../services/blockly-storage.service';
import { BlocklyVariableRegistryService } from '../services/blockly-variable-registry.service';
import { DialogRecorderIdRegistryService } from '../services/dialog-recorder-id-registry.service';
import { EditorItemsService } from '../services/editor-items.service';
import { EventIdRegistryService } from '../services/event-id-registry.service';
import { FileUploadService } from '../services/file-upload.service';
import { ProjectSecretService } from '../services/project-secret.service';
import { ProjectService } from '../services/project.service';
import { RouteShareService } from '../services/route-share.service';
import { VoiceService } from '../services/voice.service';

export const botconfigadminResolver: ResolveFn<ChatbotConfig | null> = async (route) => {


  // Start observing before this navigation completes, including direct links.
  inject(RecentBotsService);
  const loginService: LoginService = inject(LoginService);
  const adminService: AdminService = inject(AdminService);
  const rss: RouteShareService = inject(RouteShareService);
  const stageAdmin: StageAdminService = inject(StageAdminService);
  const mcpService: McpService = inject(McpService);
  const fileService = inject(FileUploadService);
  const projectService = inject(ProjectService);
  const fusionViewService = inject(FusionService);
  const blocklyStorageService = inject(BlocklyStorageService);
  const blocklyVariableRegistry = inject(BlocklyVariableRegistryService);
  const editorItemService = inject(EditorItemsService);
  const eventIdRegistry = inject(EventIdRegistryService);
  const dialogRecorderIdRegistry = inject(DialogRecorderIdRegistryService);
  const secretService = inject(ProjectSecretService);
  const botIdService = inject(BotidService);
  const voiceService = inject(VoiceService);
  const pluginService = inject(BlocklyPluginsService);


  const id = route.params['id'] as string;
  botIdService.setBotId(id);
  const botConfig = await adminService.loadBotConfig(id);
  if (botConfig) {
    projectService.selectedProject = await projectService.getProject(botConfig.projectId ?? '-');
    secretService.selectedProjectId = botConfig.projectId ?? '';

    rss.botConfig = botConfig;
    await Promise.all([
      loginService.setAdminPosition(id),
      fusionViewService.loadFusionInfo(id),
      stageAdmin.loadStages(),
      mcpService.getMcps(id),
      mcpService.loadManagesMcps(),
      fileService.getFiles(id),
      pluginService.getPlugins(),
      blocklyStorageService.loadBlocklyStages(),
      voiceService.getVoices()
    ]);
    blocklyVariableRegistry.refresh();
    eventIdRegistry.refresh();
    dialogRecorderIdRegistry.refresh();
    editorItemService.loadEditorItems();
  }
  return botConfig;
};
